/**
 * Priority navigation: collapses page links into "Other" dropdown
 * only when the navbar actually overflows.
 */
export default function priorityNav() {
    var nav = document.querySelector('.header__nav .navbar-nav');
    if (!nav) return;

    function update() {
        if (window.innerWidth < 1200) {
            nav.classList.remove('nav-collapsed');
            return;
        }

        nav.classList.remove('nav-collapsed');

        if (nav.scrollWidth > nav.clientWidth) {
            nav.classList.add('nav-collapsed');
        }
    }

    var timer;
    window.addEventListener('resize', function () {
        clearTimeout(timer);
        timer = setTimeout(update, 100);
    });

    update();
}